import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { Loading } from "components/Loading/loading";
import { Textbox } from "components/Textbox/Textbox";
import { useState } from "react";
import { trans } from "utils/helpers";


interface ItemGroupLeafFormType {
    mode?: any,
    checkData?: any,
    selectedObj:any;
    ItemGroupLeafData:any;
}

export const ItemGroupLeafForm = ({mode,selectedObj,ItemGroupLeafData,checkData}:ItemGroupLeafFormType) => {
    const [resetForm, setResetForm] = useState(false);
    const [descriptions, setDescriptions] = useState<any>({});

    return (<>
            <>
                { (mode != "create" && ItemGroupLeafData)||(mode == "create") ?
                    <div className="card-body">
                        <div className="row">
                        <div className="col-3">
                            <EnumerationTypeSelect
                                name={"ItemType"}
                                value={ItemGroupLeafData?.ItemType}
                                mode={mode}
                                label="ItemType"
                                enumTypeSelect="ItemType"
                                />
                        </div>



                        {/* <div className="col-auto ms-1 row align-items-center">
                            
                            <div className="col px-0">
                            <Textbox
                            customClass={'text-start '}
                            customeStyle={{borderRadius:'0px 5px 5px 0px'}}
                                autoFocus={true}
                                textboxType="text"
                                asNumber={true}
                                textboxName="Code"
                                required
                                resetForm={resetForm}
                                UsepadWithZeros={true}
                                maxLength={+checkData.CodeLength}
                                // addOnValue={checkData ? checkData?.ParentCode+"":checkData?.ParentCode}
                               defaultValue={(ItemGroupLeafData?.Code ?ItemGroupLeafData?.Code.replace(checkData?.ParentCode,"") : checkData?.Code)  }
                                labelText={trans("itemcode") + ( mode !== "create" ? "" : `  (${"طول مجاز"} : ${checkData.CodeLength})`)}
                                mode={mode }
                                />
                            </div>
                            <div className="col-auto  text-end pt-1 "
                            style={{padding:'4px 8px',
                                 border:'1px solid #ced4da',
                                borderRight:'0px'
                                ,borderRadius:'5px 0px 0px 5px',marginTop:'5.7px',backgroundColor:'#e9ecef',height:'27.5px'}}
                            >
                             { checkData ? checkData?.ParentCode+"":checkData?.ParentCode}
                            </div>
                          
                        </div> */}


                            <div className="col-3">
                                <Textbox
                                    textboxType="number"
                                    textboxName="Code"
                                    autoFocus={true}
                                    customClass={"arrow-none"}
                                    UsepadWithZeros={true}
                                    maxLength={+checkData.CodeLength}
                                    defaultValue={(ItemGroupLeafData?.Code ?ItemGroupLeafData?.Code.replace(checkData?.ParentCode,"") : checkData?.Code)  }
                                    addOnValue={checkData?.ParentCode+""}
                                    resetForm={resetForm}
                                    required={true}
                                    labelText={trans("itemcode") + ( mode !== "create" ? "" : `  (${"طول مجاز"} : ${checkData.CodeLength})`)}
                                    mode={mode }
                                    />
                            </div>
                          
                        </div>
                            <div className="row">

                                <div className="col-3">
                                    <Textbox
                                        required={true}
                                        onBlurHandler={(e)=>{setDescriptions({...descriptions ,summaryDescription:e })}}
                                        textboxType="text"
                                        textboxName="SummaryDescription"
                                        resetForm={resetForm}
                                        defaultValue={ItemGroupLeafData?.SummaryDescription ? ItemGroupLeafData.SummaryDescription : null}
                                        labelText="ItemGroupSummaryDescription"
                                        mode={mode}
                                        />
                                </div>
{/*                                 <div className="col-4">
                                <Textbox
                                    required={true}
                                    onBlurHandler={(e)=>{setDescriptions({...descriptions ,Description:e })}}
                                    textboxType="text"
                                    textboxName="Description"
                                    resetForm={resetForm}
                                    defaultValue={ItemGroupLeafData?.Description  ? ItemGroupLeafData?.Description : ((descriptions.Description &&descriptions.Description.length>0 )? descriptions.Description: descriptions.summaryDescription)}
                                    labelText="ItemGroupDescription"
                                    mode={mode}
                                    />
                                </div> */}
{/* 
                            </div>
                        <div className="row"> */}
                        <div className="col-3">
                                    <Textbox
                                        onBlurHandler={(e)=>{setDescriptions({...descriptions ,SummaryDescriptionEN:e })}}
                                        textboxType="text"
                                        textboxName="SummaryDescriptionEN"
                                        resetForm={resetForm}
                                        defaultValue={ItemGroupLeafData?.SummaryDescriptionEN ? ItemGroupLeafData.SummaryDescriptionEN : null}
                                        labelText="ItemGroupSummaryDescriptionEN"
                                        mode={mode}
                                        />
                                </div>
{/*                         <div className="col-4">
                                <Textbox
                                    onBlurHandler={(e)=>{setDescriptions({...descriptions ,DescriptionEN:e })}}
                                    textboxType="text"
                                    textboxName="DescriptionEN"
                                    resetForm={resetForm}
                                    defaultValue={ ItemGroupLeafData?.DescriptionEN  ? ItemGroupLeafData?.DescriptionEN : (descriptions.DescriptionEN ? descriptions.DescriptionEN: descriptions.SummaryDescriptionEN)}
                                    labelText="ItemGroupDescriptionEN"
                                    mode={mode}
                                    />
                            </div> */}
                        </div>


                       
                    </div>
                    :
                    <Loading/>
                }
            </>

        </>
    );;
}
 